import { buryPoint } from '@/Common/plugins/buried-point';

export default {
  gotoPointsEvent(type) {
    const op = {
      1: '点击弹窗-签到按钮',
      2: '弹窗-签到后去-点击【积分兑换好礼】',
      3: '右上角 “我的”-点击【我的积分】',
      4: 'home页-积分兑换增值引导-点击【去兑换】',
      5: 'home页-积分兑换增值引导-点击【去添加设备】',
      6: 'home页-积分兑换增值引导-点击【查看积分详情】',
      7: 'home页-积分兑换增值引导-点击【去做任务】',
      8: 'home页-积分兑换增值引导-点击【去赚积分】',
      9: '右上角-导航-积分图标--点击【我的积分】'
    };
    buryPoint.event({
      action: '进入“我的积分”页面-入口位置',
      eventCategory: '进入“我的积分”页面',
      eventLabel: op[type]
    });
  },
  closePointsPageEvent() {
    buryPoint.event({
      action: '进入“我的积分”页面-关闭入口',
      eventCategory: '进入“我的积分”页面'
    });
  },
  checkPointsRulesEvent() {
    buryPoint.event({
      action: '查看“我的积分”页面-查看规则',
      eventCategory: '查看“我的积分”页面'
    });
  },
  checkPointsdetailsEvent() {
    buryPoint.event({
      action: '查看“我的积分”页面-查看积分明细',
      eventCategory: '查看“我的积分”页面'
    });
  },
  checkPointsEmployeesEvent() {
    buryPoint.event({
      action: '查看“我的积分”页面-查看员工明细',
      eventCategory: '查看“我的积分”页面'
    });
  },
  checkPointsRecordsEvent() {
    buryPoint.event({
      action: '查看“我的积分”页面-查看签到记录',
      eventCategory: '查看“我的积分”页面'
    });
  },
  checkPointsAddDeviceEvent() {
    buryPoint.event({
      action: '查看“我的积分”页面-查看添加设备阶梯',
      eventCategory: '查看“我的积分”页面'
    });
  },
  completePointsSigninEvent(type) {
    const op = {
      1: '签到-home页右上角常驻签到入口-点击【签到】',
      2: '弹窗-点击【立即签到】',
      3: '我的积分-签到的积分任务-点击【签到】',
      4: '我的积分-签到的积分任务-查看签到记录-点击【立即签到】'
    };
    buryPoint.event({
      action: '完成积分任务-完成任务-签到',
      eventCategory: '完成积分任务',
      eventLabel: op[type]
    });
  },
  completePointsCloseSigninEvent() {
    buryPoint.event({
      action: '完成积分任务-完成任务-关闭签到',
      eventCategory: '完成积分任务'
    });
  },
  completePointsAddDeviceEvent() {
    buryPoint.event({
      action: '完成积分任务-完成任务-添加设备',
      eventCategory: '完成积分任务'
    });
  },
  completePointsInviteEmployeeEvent() {
    buryPoint.event({
      action: '完成积分任务-完成任务-邀请员工',
      eventCategory: '完成积分任务'
    });
  },
  completePointsCompanyEvent() {
    buryPoint.event({
      action: '完成积分任务-完成任务-认证公司',
      eventCategory: '完成积分任务'
    });
  },
  completePointsToEpEvent() {
    buryPoint.event({
      action: '完成积分任务-点击跳转EP',
      eventCategory: '完成积分任务'
    });
  }
};
